import {useCallback, useEffect, useState} from "react";
import {Area} from "@ant-design/plots";
import {useTranslation} from "react-i18next";
import {APIv1} from "../../../../../api";
import {Button} from "antd";
import {DollarOutlined, FieldNumberOutlined} from "@ant-design/icons";
import "./AnalysisLineChart.scss";

const defaultData = [
    {day: "10", income: 12.9, count: 4},
    {day: "11", income: 12.9, count: 2},
    {day: "12", income: 22, count: 6},
    {day: "13", income: 15, count: 3},
    {day: "14", income: 9.1, count: 1},
    {day: "15", income: 50, count: 12},
    {day: "16", income: 8, count: 2},
];

const AnalysisLineChart = ({provider}) => {
    const {t} = useTranslation();
    const [userData] = useState(() => {
        const stored = localStorage.getItem("user");
        return stored ? JSON.parse(stored) : {};
    });
    const [data, setData] = useState(defaultData);
    const [activeField, setActiveField] = useState("income"); // "income" or "count"

    const fetchData = useCallback(async () => {
        if (!userData?.token) return;

        try {
            const response = await APIv1.get(
                `/scan2pay/analysis/transactions/periodic/summary/?p=${provider}`,
                {headers: {Authorization: `Token ${userData.token}`}}
            );

            const mapped = response.data?.map((item) => ({
                day: item.date,
                income: item.income,
                count: item.count,
            })) || [];

            const isInvalid =
                mapped.length === 0 ||
                (mapped.every((i) => i.income === 0) &&
                    mapped.every((i) => i.count === 0));

            setData(isInvalid ? defaultData : mapped);
        } catch (error) {
            console.error("Error fetching chart data:", error);
            setData(defaultData);
        }
    }, [userData?.token, provider])

    useEffect(() => {
        fetchData();
    }, [fetchData])

    const config = {
        data,
        xField: "day",
        yField: activeField,
        shape: "smooth",
        height: 245,
        // padding: [10, 20, 40, 50], // balanced chart padding
        interaction: {tooltip: {marker: false}},
        style: {fill: "linear-gradient(-90deg, white 0%, lightgreen 100%)"},
        line: {
            shape: "smooth",
            style: {stroke: "green", lineWidth: 4},
        },
        point: {
            sizeField: 4,
            style: {stroke: "darkgreen", fill: "#fff"},
        },
        // axis: {
        //     x: {title: 'days'},
        //     y: {title: 'income'},
        // },
        xAxis: {
            title: {text: "Day", style: {fontSize: 14, fontWeight: 500, fill: "#333"}},
        },
        yAxis: {
            title: {
                text: activeField === "income" ? "Income" : "Count",
                style: {fontSize: 14, fontWeight: 500, fill: "#333"},
            },
        },
    };

    return (
        <div className="analysis-card-area">
            <div className="analysis-card-area__header">
                <h3 className="analysis-card-area__title">
                    {t("pages.scan2pay.analysis.title3")}
                </h3>
                <Button
                    type="dashed"
                    onClick={() =>
                        setActiveField(activeField === "income" ? "count" : "income")
                    }
                >
                    {activeField === "income" ? (
                        <>
                            <FieldNumberOutlined style={{marginRight: 6}}/>
                            {t("analysis.charts.lineChart.count")}
                        </>
                    ) : (
                        <>
                            <DollarOutlined style={{marginRight: 6}}/>
                            {t("analysis.charts.lineChart.price")}
                        </>
                    )}
                </Button>
            </div>

            <div className="analysis-card-area__chart">
                <Area {...config} />

                {data === defaultData && (
                    <div className="analysis-card-area__overlay">
                        <div className="analysis-card-area__overlay-title">
                            {t("pages.scan2pay.analysis.messages.warning1")}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AnalysisLineChart;
